import { Grid, Card, TextField, Divider } from "@mui/material";
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import { useTheme } from "@mui/material/styles";
import { useState } from "react";

import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip } from "recharts";

function AgentInsights({ insights }) {
  const theme = useTheme();
  const [search, setSearch] = useState("");

  if (!insights) return null;

  const { summary, distribution, top, bottom, agents } = insights;

  const filteredAgents = agents.filter((a) =>
    a.agent_name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <MDBox mt={3}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Card>
            <MDBox p={2}>
              <MDTypography variant="caption">Avg Conversion</MDTypography>
              <MDTypography variant="h5">
                {Math.round((summary?.avg_conversion_rate || 0) * 100)}%
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card>
            <MDBox p={2}>
              <MDTypography variant="caption">Total Agents</MDTypography>
              <MDTypography variant="h5">{summary?.total_agents || 0}</MDTypography>
            </MDBox>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card>
            <MDBox p={2}>
              <MDTypography variant="caption">Active Agents</MDTypography>
              <MDTypography variant="h5">{summary?.active_agents || 0}</MDTypography>
            </MDBox>
          </Card>
        </Grid>
      </Grid>

      <MDBox mt={3}>
        <Card>
          <MDBox p={2}>
            <MDTypography variant="h6">Conversion Distribution</MDTypography>

            <MDBox height={250}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={distribution}>
                  <XAxis dataKey="label" tick={{ fontSize: 10 }} />
                  <YAxis tick={{ fontSize: 10 }} />
                  <Tooltip />
                  <Bar dataKey="count" fill={theme.palette.primary.main} barSize={18} />
                </BarChart>
              </ResponsiveContainer>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>

      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} md={6}>
          <Card>
            <MDBox p={2}>
              <MDTypography variant="h6">Top Performers</MDTypography>

              <MDBox height={240}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={top} layout="vertical">
                    <XAxis
                      type="number"
                      domain={[0, 1]}
                      tickFormatter={(v) => `${Math.round(v * 100)}%`}
                      tick={{ fontSize: 10 }}
                    />
                    <YAxis
                      dataKey="agent_name"
                      type="category"
                      width={140}
                      tick={{ fontSize: 10 }}
                    />
                    <Tooltip formatter={(v) => `${Math.round(v * 100)}%`} />
                    <Bar dataKey="conversion_rate" fill={theme.palette.success.main} barSize={10} />
                  </BarChart>
                </ResponsiveContainer>
              </MDBox>
            </MDBox>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <MDBox p={2}>
              <MDTypography variant="h6">Bottom Performers</MDTypography>

              <MDBox height={240}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={bottom} layout="vertical">
                    <XAxis
                      type="number"
                      domain={[0, 1]}
                      tickFormatter={(v) => `${Math.round(v * 100)}%`}
                      tick={{ fontSize: 10 }}
                    />
                    <YAxis
                      dataKey="agent_name"
                      type="category"
                      width={140}
                      tick={{ fontSize: 10 }}
                    />
                    <Tooltip formatter={(v) => `${Math.round(v * 100)}%`} />
                    <Bar dataKey="conversion_rate" fill={theme.palette.error.main} barSize={10} />
                  </BarChart>
                </ResponsiveContainer>
              </MDBox>
            </MDBox>
          </Card>
        </Grid>
      </Grid>

      <MDBox mt={3}>
        <Card>
          <MDBox p={2}>
            {/* <MDTypography variant="h6">Agents</MDTypography> */}

            <MDBox align="center">
              <TextField
                placeholder="Search agent..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                sx={{ mt: 2, mb: 2, width: { xs: "100%", md: "30%", lg: "30%" } }}
              />
            </MDBox>

            {filteredAgents.length === 0 ? (
              <MDTypography variant="caption">No agents found</MDTypography>
            ) : (
              filteredAgents.slice(0, 20).map((a) => (
                <MDBox>
                  <MDBox key={a.agent_id} display="flex" justifyContent="space-between" mb={1.5}>
                    <MDTypography variant="body2">{a.agent_name}</MDTypography>

                    <MDTypography variant="body2">
                      {Math.round(a.conversion_rate * 100)}%
                    </MDTypography>
                  </MDBox>
                  <Divider />
                </MDBox>
              ))
            )}
          </MDBox>
        </Card>
      </MDBox>
    </MDBox>
  );
}

export default AgentInsights;
